import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteAuthorizedProfile } from '../../../../actions';

class AuthorizedProfileByProfileDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteAuthorizedProfile, authorizedProfileId } = this.props;
    dispatchDeleteAuthorizedProfile({ authorizedProfileId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

AuthorizedProfileByProfileDeleteButton.propTypes = {
  authorizedProfileId: PropTypes.number.isRequired,
  dispatchDeleteAuthorizedProfile: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteAuthorizedProfile: deleteAuthorizedProfile,
};

export default connect(
  null,
  mapDispatchToProps,
)(AuthorizedProfileByProfileDeleteButton);
